export const REFRESH = 'jora-employer/navigation/REFRESH';
export const REFRESH_SUCCESS = 'jora-employer/navigation/REFRESH_SUCCESS';
export const REFRESH_FAIL = 'jora-employer/navigation/REFRESH_FAIL';
